import { LightWeightObjectChangeTracker } from '@schoolbelle/common/object-change-tracker';
import { map } from 'rxjs/operators';

export class AngularFirebaseDatabaseStub {
  constructor(
    private tracker: LightWeightObjectChangeTracker = new LightWeightObjectChangeTracker()
  ) {
    // tracker.onContentUpdate.subscribe(e=>console.log(tracker.value));
  }
  object(pathOrRef: string | firebase.database.Reference) {
    const path =
      typeof pathOrRef === 'string' ? pathOrRef : (<any>pathOrRef).path;
    return new AngularFireObjectStub(this.tracker, path);
  }
  database = new FirebaseDatabaseStub(this.tracker);
}

export class AngularFireObjectStub {
  private tracker: LightWeightObjectChangeTracker;
  constructor(
    tracker: LightWeightObjectChangeTracker = new LightWeightObjectChangeTracker(),
    path: string = 'path'
  ) {
    this.tracker = tracker.getChildTracker(
      path.split('/').filter(s => s)
    ) as LightWeightObjectChangeTracker;
  }
  valueChanges() {
    return this.tracker.onContentUpdate.pipe(map(() => this.tracker.value));
  }
}

export class FirebaseDatabaseStub {
  constructor(
    private tracker: LightWeightObjectChangeTracker = new LightWeightObjectChangeTracker()
  ) {}
  ref(path: string): firebase.database.Reference {
    return new FirebaseRefStub(this.tracker, path) as any;
  }
}
export class FirebaseRefStub {
  private tracker: LightWeightObjectChangeTracker;
  constructor(
    tracker:
      | LightWeightObjectChangeTracker
      | LightWeightObjectChangeTracker = new LightWeightObjectChangeTracker(),
    private _path: string = '',
    private delay: number = 200
  ) {
    this.tracker = tracker.getChildTracker(
      this._path.split('/').filter(s => s)
    ) as LightWeightObjectChangeTracker;
  }
  get path(): string {
    return this._path;
  }
  child(path) {
    return new FirebaseRefStub(this.tracker, path, this.delay);
  }
  set(data: any) {
    return new Promise(resolve => {
      setTimeout(() => {
        this.tracker.set([], data);
        resolve();
      }, this.delay);
    });
  }
  get() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(this.tracker.get([]));
      }, this.delay);
    });
  }
  remove() {
    return new Promise(resolve => {
      setTimeout(() => {
        this.tracker.set([], null);
        // this.tracker.destroyTracker();
        resolve();
      }, this.delay);
    });
  }
  transaction(fn: Function) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const v_o = this.tracker.get([]);
        const v_n = fn(v_o);
        if (v_n === undefined) {
          resolve({
            committed: false,
            snapshot: new FirebaseSnapshotStub(this.tracker)
          });
        } else {
          this.tracker.set([], v_n);
          resolve({
            committed: true,
            snapshot: new FirebaseSnapshotStub(this.tracker)
          });
        }
      }, this.delay);
    });
  }
  once() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(new FirebaseSnapshotStub(this.tracker));
      }, this.delay);
    });
  }
}
export class FirebaseSnapshotStub {
  constructor(
    private tracker: LightWeightObjectChangeTracker = new LightWeightObjectChangeTracker(
      new LightWeightObjectChangeTracker(),
      ['path']
    )
  ) {}
  val() {
    return this.tracker.get([]);
  }
}
